module.exports = __webpack_public_path__ + "img/1015.f120653e.png";